<template>
  <div class="history-panel">
    <div class="tabs">
      <div  class='sites-menu' @click="dialogVisible = true">
        站点筛选<i class="el-icon-caret-bottom"></i>
      </div>

      <el-tabs v-model="mediumActive.mediumStr" @tab-click="mediumSwitch" >
        <!-- 介质选项卡-->
        <el-tab-pane
          v-for="(item, index) in this.medium"
          :name="item.MediumStr"
          :key="index"
          :label="item.mediumId"
          ref="tabPane"
          :disabled="!(item.selectMedium)">

          <!--介质名称-->
          <span slot="label" :class="[{noTab_label:!item.selectMedium},'tab_label']" >
            <span :class="[{noTab_label:!item.selectMedium}]">{{ item.MediumStr }}</span>                         
            <!-- <span class="iconfont">&#xe617;</span> -->
            <img class="icon" v-bind:src="baseUrl + '/img/' + item.Icons" />
          </span>

          <div class="menu">
            <el-form :inline="true" >

              <el-form-item label="开始时间">
                <!--日期-->
                <el-date-picker
                  v-model="start_date"
                  type="date"
                  class="start_date date-input"
                  placeholder="开始日期">
                </el-date-picker>
                <!--时间-->
                <el-time-select
                  v-model="start_time"
                  class="start_time time-input"
                  :picker-options="{
                    start: '00:00',
                    step: '00:05',
                    end: '23:59'
                  }"
                  placeholder="请选择">
                </el-time-select>
              </el-form-item>
      
              <el-form-item label="结束时间">
                <!--日期-->
                <el-date-picker
                  v-model="end_date"
                  type="date"
                  class="end_date date-input"
                  placeholder="开始日期">
                </el-date-picker>
                <!--时间-->
                <el-time-select
                  v-model="end_time"
                  class="end_time time-input"
                  :picker-options="{
                    start: '00:00',
                    step: '00:05',
                    end: '23:59'
                  }"
                  placeholder="请选择">
                </el-time-select>
              </el-form-item>

              <el-form-item label="选择预设时间">
                <el-select placeholder="预设时间" v-model="time_range" class="time_range" @change="timeRangeChange">
                  <el-option label="自定义" value="custome"></el-option>
                  <el-option label="最近一天" value="day"></el-option>
                  <el-option label="最近一周" value="week"></el-option>
                  <el-option label="最近一月" value="month"></el-option>
                  <el-option label="最近一年" value="year"></el-option>
                </el-select>
              </el-form-item>

              <!-- <el-form-item label="时间间隔" class="interval">
                <el-select placeholder="预设时间" v-model="time_range" class="time_range" @change="timeRangeChange">
                  <el-option label="自定义" value="custome"></el-option>
                  <el-option label="30分钟" value="day"></el-option>
                  <el-option label="1小时" value="week"></el-option>
                  <el-option label="2小时" value="month"></el-option>
                  <el-option label="24小时" value="year"></el-option>
                </el-select>
              </el-form-item> -->

              <!--最大行数-->
              <!-- <el-form-item label="最大行数" class="maxrowcount">
                <el-input type="number" v-model.number="maxRowCount" autocomplete="off"></el-input>
              </el-form-item> -->


              <el-button plain type="primary" class="menu-btn" @click="searchData()">
                <span>查询</span>
              </el-button>
              <!--数据导出-->
              <download-excel 
                class = "export-excel-wrapper"
                :data = "historyData"
                :fields = "exportExportFileds"
                :before-generate="exportFile"
                :name = "exportFileName">
                <el-button plain type="primary" class="menu-btn">
                  导出
                </el-button>
              </download-excel>

              <!--打印-->
              <el-button   v-print="printHistory" plain type="primary" class="menu-btn" popTitle="历史数据导出">
                打印
              </el-button>

            </el-form>

          </div>

          <!-- 表格数据 -->
          <div class="table-wrap"  id="historytable">
            <el-table
              sortable
              :max-height="tableHight"
              show-summary
              :summary-method="getSummaries"
              :data="historyData"
              v-if="historyData"
              class="history-table"
              border
              :header-cell-style="{
                background: 'rgba(78,132,255,1)',
                color: 'white',
                textAlign: 'center',
              }"
              v-load-more.expand="{func: loadMoreData, target: '.el-table__body-wrapper', delay: 300}"
              :ref="'historytable'+mediumActive.mediumId"
            >
              <el-table-column
                sortable
                height="100px"
                v-for="(item, index) in historyHeader"
                :key="index"
                :label="item.name"
                :prop="item.field"
                :class-name="'history-table-column '+item.field"
                :formatter="formatterTableColumn"
              >
              </el-table-column>

            </el-table>            
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 站点筛选--dialog -->
    <siteselect :show.sync="dialogVisible" v-if="sites&&sites.siteList" v-on:siteSelectCompleted="siteSelectCompleted"></siteselect>
  </div>
</template>

<script>
import _mean from "lodash/mean"; // 求数组平均值
import _orderBy from "lodash/orderBy"; // 对象数组排序
// 打印组件
import Print from 'vue-print-nb'

// 导出excel组件
import JsonExcel from 'vue-json-excel';

import { getHistoryData} from "@api/historyForm";
// 站点筛选组件
import SiteSelect from "@components/SiteSelect";

/** 节流函数 */
const debounce = function (func, delay) {
  let timer = null
  return function () {
    if (timer) clearTimeout(timer)
    timer = null
    let self = this
    let args = arguments
    timer = setTimeout(() => {
        func.apply(self, args)
    }, delay)
  }
}


export default {
  name: "historyForm",
  data() {
    return {
      printHistory: {
        id: "historytable",
        popTitle: '历史表格数据'
      }, // 打印配置

      baseUrl: this.$store.state.assetsUrl, // 基础请求路径
      historyHeadersObj:{}, // 全部表头数据的集合
      historyDataObj:{}, // 全部介质的数据
      historyHeader: [], //当前选中的介质的数据表头
      historyData: [], // 当前选中的介质的历史数据

      mediumActive:{
        mediumStr:"", // 介质名称
        mediumId:"", // 介质id
      }, // 选中的介质名称及其介质id号


      dialogVisible: false, //站点筛选dialog

      sites: null, // 站点数据，包括站点mediumList、siteLevel、groupList、siteList
      medium: [], // 介质类型对象，为上面的mediumList,包括介质编号及其名称
      siteList: [], //站点列表数据，为sites钟的siteList内容，站点的编号和相关的属性信息
      selectStr: "", //选中的站号的集合
      selectSiteList:[], //选中的站点集合
      tableHeader: [], //表头集合

      tableHight:400 , // 表格的高度

      start_date:'', //开始日期
      end_date:'', // 结束日期
      start_time:'', // 开始时间
      end_time:'', // 结束时间
      time_range:"custome", // 时间范围下拉框
      maxRowCount:300, // 最大行数


      exportFileName:"历史表格数据.xls", // 导出文件的名称

      btstr:'',//表头取的字符串长度。
    };
  },
  // 局部注册打印指令
  directives: {
    Print,
    // 无限滚动指令
    'load-more': {
      bind (el, binding, vnode) {
          const { expand } = binding.modifiers
          // 使用更丰富的功能，支持父组件的指令作用在指定的子组件上
          if (expand) {
              /**
               * target 目标DOM节点的类名
               * distance 减少触发加载的距离阈值，单位为px
               * func 触发的方法
               * delay 防抖时延，单位为ms
               * load-more-disabled 是否禁用无限加载
               */
              let { target, distance = 0, func, delay = 200 } = binding.value
              if (typeof target !== 'string') return
              let targetEl = el.querySelector(target)
              if (!targetEl) {
                  console.log('找不到容器')
                  return
              }
              binding.handler = debounce(function () {
                  const { scrollTop, scrollHeight, clientHeight } = targetEl
                  let disabled = el.getAttribute('load-more-disabled')
                  disabled = vnode[disabled] || disabled

                  if (scrollHeight <= scrollTop + clientHeight + distance) {
                      if (disabled) return
                      func && func()
                  }
              }, delay)
              targetEl.addEventListener('scroll', binding.handler)
          } else {
              binding.handler = helper.debounce(function () {
                  const { scrollTop, scrollHeight, clientHeight }  = el
                  if (scrollHeight === scrollTop + clientHeight) {
                      binding.value && binding.value()
                  }
              }, 200)
              el.addEventListener('scroll', binding.handler)
          }
      },
      unbind (el, binding) {
          let { arg } = binding
          // 使用更丰富的功能，支持父组件的指令作用在指定的子组件上
          if (arg === 'expand') {
              /**
               * target 目标DOM节点的类名
               * offset 触发加载的距离阈值，单位为px
               * method 触发的方法
               * delay 防抖时延，单位为ms
               */
              const { target } = binding.value
              if (typeof target !== 'string') return
              let targetEl = el.querySelector(target)
              targetEl && targetEl.removeEventListener('scroll', binding.handler)
              targetEl = null
          } else {
              el.removeEventListener('scroll', binding.handler)
              el = null
          }
      }
    }   
  },
  mounted() {
    // 获取页面高度，并设置table高度
    let windowH=window.innerHeight;
    this.tableHight=windowH-220;

    // 请求数据
    this.$nextTick(()=>{
      this.getConfig(); // 获取用户配置,并初始化各个时间控件
      this.getSiteListData();// 获取站点列表，并设置表头信息
    });

  },
  components: {
    'downloadExcel':JsonExcel,
    siteselect: SiteSelect,
  },
  computed:{
    // 用户配置数据
    configList(){
      return this.$store.getters.configList;
    },
    // 站点数据
    sites_config(){
      return this.$store.getters.getSitesConfigByPage();
      // return this.$store.getters.sites_config;
    },
    // 导出的表格的字段配置
    exportExportFileds(){
      // 获取当前的表头，然后遍历，输出符合条件的对象
      let exportFields={}
      for(let item of this.historyHeader){
        let name=item.name;
        let field=item.field;
        if(field=='RecordTime'||name=='时间'){
          exportFields[name]={
            field: field,
            callback: (value) => {
              let time=this.$moment(value).format("YYYY-MM-DDTHH:mm");
              return time;
            }
          };
        }else{
          exportFields[name]=field;
        }

      }
      return exportFields;
    }
  },
  methods: {
    // 获取用户配置
    async getConfig(){
      let config  = this.configList;
      let firstToData= config.history_time.startTimeForCustom; // 开始日期
      // 返回的时间可能是这样的20-11-02 09:22，没有前面的年份，所以需要进行处理
      // 至于为什么返回了这么样的数据，还是因为历史原因
      if(firstToData.substr(0,firstToData.indexOf("-")).length<4){
        firstToData=20+firstToData;
      }
      this.start_date= this.$moment(firstToData).format('yyyy-MM-DD'); // 开时日期
      this.start_time=this.$moment(firstToData).format('HH:mm'); // 开始时间

      // 格式化结束日期和时间
      let endToData =config.history_time.endTimeForCustom; // 结束日期
      if(endToData.substr(0,firstToData.indexOf("-")).length){
        endToData=20+endToData;
      }
      this.end_date= this.$moment(endToData).format('yyyy-MM-DD'); // 开时日期
      this.end_time=this.$moment(endToData).format('HH:mm'); // 开始时间

    },
    /* 获取历史数据 */
    async getHistoryData(){
      // 获取开始和结束时间
      let start_dt = this.$moment(this.start_date).format("yyyy-MM-DD")+" "+this.start_time;// 拼接开始时间
      let end_dt = this.$moment(this.end_date).format("yyyy-MM-DD")+" "+this.end_time;// 拼接结束时间

      // 未选中任何站点
      if(!this.selectStr){
        this.$message({
          message:"没有选中任何站点",
          type:"warning"
        });
        this.historyData=[];
        return;
      }

      // 判断时间是否符合要求
      if(!this.$moment(start_dt).isBefore(end_dt)){
        this.$message({
          message:"开始时间应该早于结束时间",
          type:"warning"
        });
      }else{
        // 获取当前选中的介质编号
        let activeMediumId=this.mediumActive.mediumId;
        let tempData=this.historyDataObj[activeMediumId];
        let page=tempData.page;// 当前页数
        let size=tempData.size; // 每页的条数
        let data =await getHistoryData(start_dt,end_dt,this.selectStr,activeMediumId,{"RecordTime":"ASC"},page,size); // 请求历史数
        if(data.status!==500){
          // 合并数组内容
          let t=tempData.data;
          t.push.apply(t,data);
          // 如果返回的数据为空，说明没有数据了
          if(data.length<=0){
            tempData.hasData=false; 
          }
          // 如果数据较少，需要继续请求，直到出现滚动条
          if(tempData.hasData&&t.length<=20){
            tempData.page++;
            this.getHistoryData();
          }else{
            // 显示数据
            this.historyData=tempData.data;
          }
        }
      }   
    },
    // 获取站点数据
    async getSiteListData() {
      //接入接口，获取数据
      let data = this.sites_config;
      this.sites =  data;
      // 设置介质类型
      this.medium = data.mediumList;
    
      //将介质编号添加到对象中去
      for (let mediumId in this.medium) {
        this.medium[mediumId].mediumId = mediumId;
      }

      // //设置站点列表的数据
      this.siteList = data.siteList;

      //遍历全部站点，筛选出已被选中的站点
      this.getSelectedSites(this.siteList);

      // 初始化表头数据
      this.getTableHeader();
    
      // 显示第一个表头
      let init_mediumId=Object.keys(this.medium)[0];
      //设置选中的介质名称及其编号
      this.mediumActive.mediumStr=this.medium[init_mediumId].MediumStr;
      this.mediumActive.mediumId=init_mediumId;

      // 设置选中的表头
      this.historyHeader=this.historyHeadersObj[init_mediumId];

      // 获取历史数据
      this.getHistoryData();

    },
    // 初始化表头数据
    getTableHeader() {
      let medium_config = this.configList.medium_config;
      // 遍历介质类型的中英文字段映射表，生成不同类型的表头
      for (let mediumId in medium_config) {
        //  medium_config.propsItem = header;
        let mediumItem=medium_config[mediumId];
        let headerArray=[];
        // 遍历每一个字段，保存相应的内容
        for (let filedName in mediumItem.fields) {
          let fileItem=mediumItem.fields[filedName];
          let headerItem={};

          // 如果字段中的page属性显示为all.或者是current，或者是page字段不存在，则显示该字段
          // 是否为空的时候也显示，还需要进一步和后台确定
          if (fileItem.page == "all" ||fileItem.page == "history"||!fileItem.page) {
            headerItem.name = fileItem.name; // 字段的中文名
            headerItem.field = filedName; // 字段英文名
            headerArray.push(headerItem);
          }
        }
        // 保存表头
        this.historyHeadersObj[mediumId]=headerArray;

        // 创建空的介质数据集合
        this.historyDataObj[mediumId]={
          page:0, // 当前页数
          size:50, // 每页条数
          hasData:true, // 是否还有数据
          data:[], // 数据列表
        }
      }
    },
    // 介质类型切换
    mediumSwitch(tab) {
      // 更换表格列表数据
      let mediumId=tab.label;
      this.historyHeader = this.historyHeadersObj[mediumId];

      // 设置选中的介质编号和名称
      this.mediumActive.mediumStr=tab.name;
      this.mediumActive.mediumId=mediumId;

      // 重新请求历史数据
      this.historyData=[];
      let activeMediumId=this.mediumActive.mediumId;
      let tempData=this.historyDataObj[activeMediumId];
      tempData={
        page:0, // 当前页数
        size:50, // 每页条数
        hasData:true, // 是否还有数据
        data:[], // 数据列表
      };

      this.getHistoryData();
    },
    // 查询按钮更新数据
    searchData(){
      // 重新请求历史数据
      this.historyData=[];
      let activeMediumId=this.mediumActive.mediumId;
      let tempData=this.historyDataObj[activeMediumId];
      tempData={
        page:0, // 当前页数
        size:50, // 每页条数
        hasData:true, // 是否还有数据
        data:[], // 数据列表
      };
      this.historyDataObj[activeMediumId]=tempData;

      this.getHistoryData();
    },
    // 获取选中的站点列表
    getSelectedSites(siteList){
      //遍历全部站点，筛选出已被选中的站点
      //存放选中的数据
      var selectSiteList = [];
      for (let groupId in siteList) {
        let groupSites = siteList[groupId];
        for (let siteId in groupSites) {
          //拿到对应单个数据
          let siteItem = groupSites[siteId];
          if (siteItem.now == true) {
            selectSiteList.push(siteItem);
          }
        }
      }
      this.selectSiteList=selectSiteList;

      //得到选中站点的索引值
      var selectStr = "";
      for (var i = 0; i < selectSiteList.length; i++) {
        selectStr += selectSiteList[i].SiteNo + ",";
      }
      selectStr = selectStr.substr(0, selectStr.length - 1);
      // 保存选中的列表
      this.selectStr = selectStr;
    },
     //站点选择完成之后
    siteSelectCompleted(selectedSites) {
      // 更新选中的站点数据
      this.getSelectedSites(selectedSites);

      // 重新请求历史数据
      this.historyData=[];
      let activeMediumId=this.mediumActive.mediumId;
      let tempData=this.historyDataObj[activeMediumId];
      tempData={
        page:0, // 当前页数
        size:50, // 每页条数
        hasData:true, // 是否还有数据
        data:[], // 数据列表
      };
      this.historyDataObj[activeMediumId]=tempData;


      this.getHistoryData();
    },
    // 格式化table列
    formatterTableColumn(row,column,cellValue){
      let RecordTime=row.RecordTime;
      if(column.property=="RecordTime"){
        return RecordTime?RecordTime.replace(" ","\n"):"";
      }else{
        return cellValue;
      }     
    },
    // 导出文件
    exportFile(){
      let start_date= this.$moment(this.start_date).format('yyyy-MM-DD'); // 开时日期
      let statTime=this.start_time.replace(":","-");

      let end_date= this.$moment(this.end_date).format('yyyy-MM-DD'); // 结束日期
      let endTime=this.end_time.replace(":","-");

      this.exportFileName="历史表格数据_"+start_date+"_"+statTime+"至"+end_date+"_"+endTime+".xls";
    },
    // 显示统计内容
    getSummaries(param){
      const { columns, data } = param;
      let temData=_orderBy(data,['RecordTime'],['asc']); // 对数据进行排序
      const sums = [];
      // 判断选中的站点数量，如果选中了一个站点，则有累计，如果多个站点，则没有累计值
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if(column.property=="SiteName"||column.property=="RecordTime"||column.property=="Alarm"){
          sums[index] = '';
          return;
        }
        const values = temData.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          if(column.label. indexOf("累积")>=0){ // 如果是累积值，则用按时间排序后的最后一条数据，减去第一条数据
            if(this.selectSiteList.length>1){
              sums[index] ="";
            }else{
              sums[index] ="用量\n"+(values[values.length-1]-values[0]).toFixed(3);
            }
            
          }else{ // 否则求平均值
            sums[index] = ' 平均值\n'+_mean(values).toFixed(3);
          }
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },
    // 预设时间改变
    timeRangeChange(val){
      let now=this.$moment();
      this.end_date= now.format('yyyy-MM-DD'); // 结束日期
      this.end_time=now.format('HH:mm'); // 结束时间
      // 开始时间
      let end=now.add(-1,val);
      this.start_date= end.format('yyyy-MM-DD'); // 开时日期
      this.start_time=end.format('HH:mm'); // 开始时间      
    },

    // 无限滚动加载数据
    loadMoreData(){
      let medium=this.mediumActive;
      let tempData=this.historyDataObj[medium.mediumId];
      // 还有数据的时候，要继续请求
      if(tempData.hasData){
        tempData.page++;
        this.getHistoryData();
      }
    },
  },
};
</script>

<style lang="scss">
.history-panel{
  .tabs {   
    .el-tabs__header {
      padding-left: 10px;
      padding-right: 34px;
      background: white;
      height: 50px;
      line-height: 51px;
      margin: 0 0 5px;
    }
    .el-tabs__content{
      padding:10px;
    }
    /**介质图标 */
    .icon {
      width: 30px;
      height: 30px;
      vertical-align: middle;
      margin-left: 5px;
    }
  
    // 介质标题
    .tab_label {
      display: inline-block;
      min-width: 100px;
      text-align: center;
      font-size: 18px;
      font-family: YaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }

    /**站点删选按钮 */
    .sites-menu{
      position: absolute;
      right: 10px;
      z-index: 10;
      color: #333;
      font-size: 14px;
      cursor: pointer;
      background: white;
      height: 50px;
      line-height: 50px;
      padding-left: 34px;
      margin-bottom: 10px;
      display: flex;
      flex-direction:row;
      justify-content:space-between;
      align-items:Center;
    }

  }

  // 表格
  .table-wrap{
    position: absolution;
    width: 100%;

    .history-table {
      overflow: hidden;

      .sort-caret.ascending {
        border-bottom-color: white !important;
      }
      .sort-caret.descending {
        border-top-color: white !important;
      }
      // 总厂那行高亮
      .el-table .warning-row {
        background: rgba(221, 231, 255, 1);
      }
      /**单元格居中 */
      .history-table-column {
        text-align: center !important;
        padding: 0;
      }
    }
    /** 时间列的单独配置 */
    .el-table .RecordTime .cell{
      word-break:initial;
      white-space: pre;
    }

  }
  /**菜单栏 */
  .menu{
    padding:10px;
    background: #fff;
    
    .el-form-item{
      margin-bottom: 0;
    }
    /**菜单栏按钮 */
    .menu-btn {
      height: 40px;
      margin-right: 10px;
      span {
        font-size: 16px;
        font-weight: 400;
      }
    }
    .date-input{
      width:135px;
      input {
        width:130px;
        padding-right: 15px;
      }
    }
    .time-input{
      width:100px;
      input {
        width:90px;
        padding-right: 10px;
      }
    }
    
    .time_range{
      width:120px;
    }
    .maxrowcount{
      input{
        width: 100px;
        padding:0 0 0 5px;
      }

    }

    .export-excel-wrapper{
      display: inline-block;
    }
  }
}
</style>    